import { Component, OnInit } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { DuplicateTradingPlanEntry } from "../../../../../api/models/duplicate-trading-plan-entry";
import { QualityGateService } from "../../../../../api/services/quality-gate.service";
import { MessageService } from "primeng/api";
import { PlanActionEntry } from "../../../../../api/models/plan-action-entry";
import { QualityGateSubmission } from "../../../../../api/models/quality-gate-submission";
import { QualityGateFilter } from "../../../../../api/models/quality-gate-filter";
import { QualityGateMultiSubmission } from "../../../../../api/models/quality-gate-multi-submission";
import { ViewFilingsComponent } from "../../modals/view-filings/view-filings.component";
import { ViewDuplicatePlansFilingsComponent } from "../../modals/view-duplicate-plans-filings/view-duplicate-plans-filings.component";

@Component({
  selector: "app-duplicate-plans-processed",
  // imports: [],
  templateUrl: "./processed.component.html",
  styleUrl: "./processed.component.css",
  standalone: false,
})
export class DuplicatePlansProcessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // unprocessedFlags: [] = [];
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  processedDuplicatePlansEntries: DuplicateTradingPlanEntry[] = [];
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getProcessedDuplicatePlans();
  }

  onExcludeClick(share: PlanActionEntry) {
    const submission: QualityGateSubmission = {
      qualityGateType: "Duplicate_Trading_Plan",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: 0,
      },
      planActionSubmission: {
        entryId: share.entryId ?? 0,
      },
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.getProcessedDuplicatePlans();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }

  onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getProcessedDuplicatePlans();
  }

  getProcessedDuplicatePlans() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "PROCESSED",
      qualityGateType: "Duplicate_Trading_Plan",
      issuerName: this.issuerName ? this.issuerName : undefined,
      insiderName: this.insiderName ? this.insiderName : undefined,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.processedDuplicatePlansEntries =
          value.duplicateTradingPlanEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.processedDuplicatePlansEntries?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  onGroupExclusionClick() {
    const entryIds = this.selectedTag
      .filter((share) => share.entryId !== undefined)
      .map((share) => share.entryId);
    const submission: QualityGateMultiSubmission = {
      entryIds: entryIds,
      indeterminable: true,
      qualityGateType: "Duplicate_Trading_Plan",
    };

    this._qualityGateService.multiSubmission(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.selectedTag = [];
        this.getProcessedDuplicatePlans();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }

  viewFilingsModal(rowData: any) {
    console.log("test1", rowData);
    this.ref = this.dialogService.open(ViewDuplicatePlansFilingsComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "60vw" },
      contentStyle: { overflow: "auto" },
      header: "Plans",
      data: rowData,
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getProcessedDuplicatePlans();
      }
    });
  }
}
